import request from '../request';
import { userUrl, codeUrl, judgeUrl, pkaUrl, wxUrl } from '@/utils/request'
import qs from 'qs'

export const loginBybangding = (username, password, openid) => {
  let dataObj = { 'phone': username, 'pwd': password, 'openid': openid }

  // 保存当前选中的 basic 认证信息

  return request({
    url: 'https://user.3class.cc/api/user/v1/weichat_bind',
    method: 'post',
    data: dataObj
  })
}

export const loginByUsername = (username, password, code, randomStr) => {
  let grant_type = 'password'
  let dataObj = { 'phone': username, 'pwd': password }
  let basicAuth = 'Basic ' + window.btoa("pig:pig")

  // 保存当前选中的 basic 认证信息

  return request({
    url: 'https://user.3class.cc/api/user/v1/login',
    method: 'post',
    data: dataObj
  })
}


//检测用户是否在微信上进行操作
export function wxlogincheck(data) {
  return request({
    url: wxUrl + "/get_login_redis",
    method: 'post',
    data: data,

  })
}

//获取微信登录二维码
export function wxloginimg(data) {
  return request({
    url: wxUrl + "/pcQrCode",
    method: 'get',
    data: data,

  })
}


//获取思科文件上传记录
export function getTrueJudge(data) {
  return request({
    url: pkaUrl + "/getTrueJudge",
    method: 'get',
    data: data,

  })
}
//获取思科文件上传日历
export function getdatelist(data) {
  return request({
    url: pkaUrl + "/dateList",
    method: 'get',
    data: data,

  })
}
//上传文件
export function upload(data) {
  return request({
    url: judgeUrl + "/upload_pka",
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: data,

  })
}

//获得图形验证码
export function getimg(data) {
  return request({
    // https://user.3class.cc/api/user/v1/login
    url: userUrl + "/captcha",
    method: 'get',
    responseType: "arraybuffer", // 类型
    data: data,

  })
}

export function real_name_auth(data) {
  return request({
    url: userUrl + "/real_name_auth",
    method: 'post',
    data: data,
  })
}
export function postregisterphonecode(data) {
  return request({
    url: userUrl + "/send_phone_code",
    method: 'post',
    params: data,
  })
}

//获取手机验证码
export function postphonecode(data) {
  return request({
    url: userUrl + "/change_phone_code",
    method: 'post',
    params: data,

  })
}
//修改密码
export function change_pwd(data) {
  return request({
    url: userUrl + "/change_pwd",
    method: 'post',
    data: data,

  })
}
// 注册
export function register(data) {
  return request({
    url: userUrl + "/register",
    method: 'post',
    data: data,
  })
}
//登录
export function testlogin(data) {
  return request({
    url: userUrl + "/login",
    method: 'post',
    data: data,

  })
}

/**
 * 注册用户
 */
export const registerUser = (userInfo) => {
  return request({
    url: codeUrl + '/admin/register/user',
    method: 'post',
    headers: {
      "Content-Type": 'application/json; charset=UTF-8'
    },
    data: JSON.stringify(userInfo)
  })
}
//修改用户信息
export function changeuserinfo(data) {
  return request({
    url: userUrl + "/change_user_info",
    method: 'post',
    data: data
  })
}

//用户详情
export function detail(data) {
  return request({
    url: userUrl + "/detail",
    method: 'get',
    data
  })
}


//获取用户思科文件列表

export function getsicolist(data) {
  return request({
    url: pkaUrl + "/pka_list",
    method: 'post',
    data
  })
}

//获取用户思科文件成绩

export function score_detail(data) {
  return request({
    url: pkaUrl + "/score_detail",
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/utils/api/user.js